import React, {useState} from 'react';
import './FaqSection.less';
import openedVector from '../../assets/icons/Vector (1).png';
import closedVector from '../../assets/icons/Vector (2).png';
import {faqData} from './homeData';
import {Link} from 'react-router-dom';

const FaqSection: React.FC = () => {
	const [activeIndexes, setActiveIndexes] = useState<number[]>([]);

	const toggleAccordion = (index: number) => {
		setActiveIndexes(prevActiveIndexes =>
			prevActiveIndexes.includes(index)
				? prevActiveIndexes.filter(i => i !== index)
				: [...prevActiveIndexes, index]
		);
	};

	return (
		<div className="faq-section-container">
			<p className="home-faq-subtitle">FAQs</p>
			<h1 className="faq-home-title">Frequently Asked Questions</h1>
			<div className="faq-items-container">
				{faqData.map((faq, index) => (
					<div key={index} className="faq-section-item">
						<button className="faq-question" onClick={() => toggleAccordion(index)}>
							<h3 className="home-faq-question-h3">{faq.question}</h3>
							<span>
								<img
									src={activeIndexes.includes(index) ? openedVector : closedVector}
									alt="toggle icon"
									className="faq-icon"
								/>
							</span>
						</button>
						{activeIndexes.includes(index) && (
							<div className="faq-answer">
								<span>{faq.answer}</span>
								<br />
								{faq.hasLink && (
									<>
										<br />
										<span>
											See the
											<a
												href="https://www.swift.com/about-us/partner-programme/shared-infrastructure-programme/service-bureau-directory"
												className="faq-link">
												link
											</a>
										</span>
									</>
								)}
							</div>
						)}
					</div>
				))}
			</div>
			<div className="faq-footer">
				Haven’t got your answer?{' '}
				<Link to="/contact-us" className="faq-support-link">
					Contact our support now
				</Link>
			</div>
		</div>
	);
};

export default FaqSection;
